import React, { Component } from "react";
import IAgreeTerms from "../../common/components/pageBlocks/declaration/iAgreeTerms";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import ModalPopUp from "../../common/components/pageBlocks/modalPopUp";
import commonContext, { AppContext } from "../../common/context/common";
import htmlParse from "html-react-parser";
import InputForm from "../../common/components/html/inputForm";
import OtpPopUp from "../../common/components/otpPopUp";
import IAgreeTermsInsurence from "../../common/components/pageBlocks/declaration/iAgreeTermsInsurence";
import { leadType } from "../../app";
import { CommonApis } from "../../common/apis/commonApis";
import { Qm10SecApis } from "../apis/qm10SecApis";

interface IProps {
    history: any;
}
interface IState {
    IAgreeToTermSwitch: boolean;
    IAgreeToTerm: boolean;
    IAgreeToTermInsuranceSwitch: boolean;
    IAgreeToTermInsurance: boolean;
    insuranceSwitch: boolean;
    otpPopUpSwitch: boolean;
    IAgreeToTermError: boolean;
    IAgreeToTermInsuranceError: boolean;
    captchaError: boolean;
}
export class Declaration extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    apis: Qm10SecApis;
    commonAPI: CommonApis;
    setLead: Function;
    constructor(props: IProps) {
        super(props);
        this.state = {
            IAgreeToTermSwitch: false,
            IAgreeToTerm: false,
            IAgreeToTermInsuranceSwitch: false,
            IAgreeToTermInsurance: false,
            otpPopUpSwitch: false,
            insuranceSwitch: false,
            IAgreeToTermError: false,
            IAgreeToTermInsuranceError: false,
            captchaError: false,
        };
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.apis = (this.context as AppContext).apis as Qm10SecApis;
        this.setLead = (this.context as AppContext).setLead;
        this.lead = (this.context as AppContext).lead as leadType;
        this.commonAPI = (this.context as AppContext).commonAPI as CommonApis;
        const apiData = await this.commonAPI.getCaptcha(this.lead);
        this.setLead(apiData?.result);
    }
    handleOnCaptchaReset = async () => {
        const apiData = await this.commonAPI.getCaptcha(this.lead);
        this.setLead(apiData?.result);
    };
    handleOnSubmit = async (e) => {
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;
        this.setState({
            IAgreeToTermError: false,
            IAgreeToTermInsuranceError: false,
            captchaError: false,
        });
        if (!this.state.IAgreeToTerm) {
            return this.setState({ IAgreeToTermError: true });
        }
        if (!this.state.IAgreeToTermInsurance) {
            if (this.lead.motorInsuranceAvailed || this.lead.insuranceAvailed) {
                return this.setState({ IAgreeToTermInsuranceError: true });
            }
        }
        await this.setLead({ loadingBtn: "loadingBtn" });
        const apiData = await this.apis.acceptTermCondition({
            ...this.lead,
            termCondition: true,
            encryptedInput: this.lead.captchaInput,
        });
        if (apiData.error?.error) {
        }
        this.setState({ otpPopUpSwitch: true });
        await this.setLead({ loadingBtn: "" });
    };
    handleOnOTPSubmit = async () => {
        this.lead = (this.context as AppContext).lead as leadType;
        await this.setLead({ loadingBtn: "loadingBtn" });
        const apiData = await this.apis.finalSubmit(this.lead);
        await this.setLead({ loadingBtn: "" });
        if (apiData.result?.inValidOTP) {
            this.setLead({ confirmStatus: false });
        } else if (apiData.result?.loanAvailed) {
            this.setLead({ confirmStatus: true });
        } else {
            this.setLead({ confirmStatus: false });
        }
        this.props.history.push("confirmation");
    };
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="declaration-wrap mt-110">
                        <div className="container mx-auto px-5">
                            <h1 className="openSans-Reg text-black my-5 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                                Declaration
                            </h1>
                            {/* <!-- <a href="javascript:;" className="modal-open mr-3" data-toggle="modal" data-target="termsConditionModal">sarva-suraksha-info</a> --> */}
                            <form onSubmit={(e) => this.handleOnSubmit(e)}>
                                <div className="custom-inputs tnc-general-inputs mt-4 mb-8 openSans-SemiBold text-sm md:text-lg xl:text-xl blue-link-color">
                                    <label className="inline-flex">
                                        <input
                                            type="checkbox"
                                            onChange={() =>
                                                this.setState({
                                                    IAgreeToTerm: !this.state
                                                        .IAgreeToTerm,
                                                })
                                            }
                                            checked={this.state.IAgreeToTerm}
                                        />
                                        <span></span>
                                        <span className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg">
                                            I agree to and accept{" "}
                                            <a
                                                href="javascript:;"
                                                className="modal-open blue-link-color no-underline hover:underline hover:text-black transition-all openSans-SemiBold"
                                                data-toggle="modal"
                                                data-target="termsConditionModal"
                                                onClick={() =>
                                                    this.setState({
                                                        IAgreeToTermSwitch: true,
                                                    })
                                                }
                                            >
                                                (i) Declaration on relationship
                                                with Directors of Banks, (ii)
                                                Most Important Terms and
                                                Conditions, (iIi) Acceptance as
                                                per IT Act 2000, (iv) Acceptance
                                                of Fees and Charges, (v)
                                                Acceptance of Motor Insurance
                                                Terms and Conditions
                                            </a>
                                        </span>
                                    </label>
                                </div>
                                <span
                                    className={`${
                                        this.state.IAgreeToTermError
                                            ? ""
                                            : "hidden"
                                    } error-msg-relative text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm`}
                                >
                                    Please check
                                </span>
                                {this.lead.motorInsuranceAvailed ||
                                this.lead.insuranceAvailed ? (
                                    <>
                                        <div className="custom-inputs tnc-sarvsuraksha-inputs mt-4 mb-8 openSans-SemiBold text-sm md:text-lg xl:text-xl blue-link-color">
                                            <label className="inline-flex">
                                                <input
                                                    type="checkbox"
                                                    onChange={() =>
                                                        this.setState({
                                                            IAgreeToTermInsurance: !this
                                                                .state
                                                                .IAgreeToTermInsurance,
                                                        })
                                                    }
                                                    checked={
                                                        this.state
                                                            .IAgreeToTermInsurance
                                                    }
                                                />
                                                <span></span>
                                                <span className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg">
                                                    I agree to and accept all
                                                    terms & conditions for{" "}
                                                    <a
                                                        href="javascript:;"
                                                        className="modal-open blue-link-color no-underline hover:underline hover:text-black transition-all openSans-SemiBold"
                                                        data-toggle="modal"
                                                        data-target="termsConditionModal"
                                                        onClick={() =>
                                                            this.setState({
                                                                insuranceSwitch: true,
                                                            })
                                                        }
                                                    >
                                                        {" "}
                                                        {this.lead
                                                            .motorInsuranceAvailed &&
                                                        this.lead
                                                            .insuranceAvailed
                                                            ? "(i) Sarv Suraksha Insurance,  (ii) HDFC Motor Insurance"
                                                            : this.lead
                                                                  .insuranceAvailed
                                                            ? "(i) Sarv Suraksha Insurance,"
                                                            : this.lead
                                                                  .insuranceAvailed
                                                            ? "(ii) HDFC Motor Insurance"
                                                            : "(i) HDFC Motor Insurance"}
                                                    </a>
                                                </span>
                                            </label>
                                        </div>
                                        <span
                                            className={`${
                                                this.state
                                                    .IAgreeToTermInsuranceError
                                                    ? ""
                                                    : "hidden"
                                            } error-msg-relative text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm`}
                                        >
                                            Please check
                                        </span>
                                    </>
                                ) : (
                                    ""
                                )}
                                <div className="flex flex-wrap">
                                    <div className="m-3 w-full md:w-3/12 inline-flex justify-center md:justify-start">
                                        {this.lead.img
                                            ? htmlParse(this.lead.img)
                                            : ""}
                                        <input
                                            type="button"
                                            className="captcha-refresh"
                                            value=""
                                            onClick={() =>
                                                this.handleOnCaptchaReset()
                                            }
                                        />
                                    </div>
                                    <div className="w-full md:w-3/12 relative">
                                        <InputForm
                                            label="Enter Code"
                                            handlerOnChange={(e) =>
                                                this.setLead({
                                                    captchaInput:
                                                        e.target.value,
                                                })
                                            }
                                            errorText="Please Input Correct Captcha Code"
                                            error={this.state.captchaError}
                                            errorClass="input-info-fix"
                                        />
                                    </div>
                                </div>
                                <div className="w-full flex flex-wrap my-8">
                                    <button
                                        className={
                                            "button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue mb-2 mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4 " +
                                            this.lead.loadingBtn
                                        }
                                    >
                                        Continue
                                    </button>
                                </div>
                            </form>
                        </div>
                    </section>
                </div>
                {/* <!-- Terms & Conditions Popup Start --> */}
                {this.state.IAgreeToTermSwitch ? (
                    <ModalPopUp
                        onclickhandler={() =>
                            this.setState({ IAgreeToTermSwitch: false })
                        }
                    >
                        <IAgreeTerms
                            onclickhandler={() =>
                                this.setState({
                                    IAgreeToTermSwitch: false,
                                    IAgreeToTerm: true,
                                })
                            }
                        />
                    </ModalPopUp>
                ) : (
                    ""
                )}
                {/* <!-- Terms & Conditions Popup End -->  */}
                {/* insurence popup start */}
                {this.state.insuranceSwitch ? (
                    <ModalPopUp
                        onclickhandler={() =>
                            this.setState({ insuranceSwitch: false })
                        }
                    >
                        <IAgreeTermsInsurence
                            onclickhandler={() =>
                                this.setState({
                                    insuranceSwitch: false,
                                    IAgreeToTermInsurance: true,
                                })
                            }
                            onclickhandlerCancel={() =>
                                this.setState({
                                    insuranceSwitch: false,
                                })
                            }
                        />
                    </ModalPopUp>
                ) : (
                    ""
                )}
                {/* insurence popup end */}
                {/* <!-- OTP Popup Start --> */}
                {this.state.otpPopUpSwitch ? (
                    <OtpPopUp
                        onClose={() => this.setState({ otpPopUpSwitch: false })}
                        handleOnOTPSubmit={() => this.handleOnOTPSubmit()}
                    />
                ) : (
                    ""
                )}

                {/* <!-- OTP Popup End -->  */}
            </>
        );
    }
}

export default Declaration;
